// Shared persona color definitions for charts and components
// These must match the PERSONA_INFO in mockData.js

export const PERSONA_COLORS = {
  'Model Clients': '#10b981',      // Emerald - Best performers
  'Stable Performers': '#3b82f6',  // Blue - Reliable contributors
  'Premium Service': '#8b5cf6',    // Purple - High-touch but profitable
  'Scale Up': '#06b6d4',           // Cyan - Growth opportunity
  'Optimize': '#f59e0b',           // Amber - Efficiency focus
  'Turnaround': '#f97316',         // Orange - Restructure needed
  'At Risk': '#f43f5e',            // Rose - Needs attention
  'Critical Review': '#ef4444',    // Red - Immediate action
  'Unknown': '#94a3b8'             // Slate - Missing data
};

// Color mapping by health status (for gradients and summaries)
export const HEALTH_COLORS = {
  excellent: '#10b981',  // >50% margin
  good: '#3b82f6',       // 20-50% margin
  marginal: '#f59e0b',   // 0-20% margin
  unprofitable: '#ef4444' // <0% margin
};

// Cohort groupings for analysis
export const COHORT_GROUPS = {
  healthy: ['Model Clients', 'Stable Performers', 'Premium Service'],
  growth: ['Scale Up'],
  attention: ['Optimize', 'Turnaround'],
  critical: ['At Risk', 'Critical Review']
};
